<template>
	<section class="faq-section align-center">
		<div class="row faq">
			<div class="columns column12">
				<h2>{{ header }}</h2>
				<div class="columns column12">
					<div class="collapse-container">
						<collapse v-for="item in items" :key="item.ID" :header="item.question" :content="item.answer" />
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.faq-section {
	h2 {
		margin-bottom: 50px;
	}

	.collapse-container {
		background-color: #f9f9f9;
	}

	@media (max-width: 580px) {
		.faq-section {
			h2 {
				font-size: 30px;
			}
		}
	}
}
</style>
